import { getAllUserDevice } from 'src/@api/login'

/** 侧栏设备 / 未绑订单刷新事件（Equipment / AndroidEquipment 监听） */
export const SIDEBAR_DEVICES_REFRESH_EVENT = 'sidebarDevicesRefresh'

/**
 * 绑定完成后刷新侧栏：
 * 1. 重拉 getAllUserDevice 写入 allDeviceUser
 * 2. 广播事件，驱动侧栏再请求设备列表 + getNotBindOrder
 */
export const refreshSidebarDevices = async () => {
  if (typeof window === 'undefined') return { ok: false }

  try {
    const res = await getAllUserDevice({})
    localStorage.setItem('allDeviceUser', JSON.stringify(Array.isArray(res?.data) ? res.data : []))
  } catch (e) {
    console.error('【refreshSidebarDevices】getAllUserDevice 失败', e)
  }

  window.dispatchEvent(new CustomEvent(SIDEBAR_DEVICES_REFRESH_EVENT))

  return { ok: true }
}

export default refreshSidebarDevices
